import { Component, inject, Inject } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { EditProfile, Profile } from '../../../core/models/users.interface';
import { ProfileService } from '../../../core/services/profile/profile';
import { HttpErrorResponse } from '@angular/common/http';
import { LoadingService } from '../../../core/services/loading/loading';

@Component({
  selector: 'app-edit-password',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatCheckboxModule,
    MatIcon,
    AngularDualListBoxModule,
    MatError,
  ],
  templateUrl: './edit-password.html',
  styleUrl: './edit-password.css',
})
export class EditPassword {
  selectedProfile: Profile | null = null;
  showPasswordMatchError = false;
  private formBuilder = inject(FormBuilder);
  errorMsg: string[] | null = null;

  constructor(
    private dialogRef: MatDialogRef<EditPassword>,
    private toastr: ToastrService,
    private profileService: ProfileService,
    private loadingService: LoadingService,
    @Inject(MAT_DIALOG_DATA) public data: { selectedProfile: Profile },
  ) {}

  ngOnInit(): void {
    this.selectedProfile = this.data.selectedProfile;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  matchPassword: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    let pass = group.get('password')?.value;
    let confirmPass = group.get('confirmPassword')?.value;
    return pass === confirmPass ? null : { notSame: true };
  };

  editPasswordForm = this.formBuilder.group(
    {
      password: ['', [Validators.required, Validators.minLength(4)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(4)]],
    },
    { validators: this.matchPassword },
  );

  updatePassword() {
    this.showPasswordMatchError = true;
    if (this.selectedProfile) {
      const payload: EditProfile & { id: number } = {
        first_name: this.selectedProfile.first_name,
        last_name: this.selectedProfile.last_name,
        email: this.selectedProfile.email,
        username: this.selectedProfile.username,
        password: this.editPasswordForm.get('password')?.value ?? '',
        confirmPassword: this.editPasswordForm.get('confirmPassword')?.value ?? '',
        id: this.selectedProfile.id,
      };

      if (this.editPasswordForm.status === 'VALID') {
        this.loadingService.show(true);
        this.profileService.editPassword(this.selectedProfile.id, payload).subscribe({
          next: () => {
            this.loadingService.show(false);
            const msg = `La contraseña fue actualizada correctamente!`;
            this.toastr.success(msg, 'Exitoso!', {
              progressBar: true,
              timeOut: 5000,
            });
            this.dialogRef.close();
          },
          error: ({}: HttpErrorResponse) => {
            if (this.errorMsg) {
              this.loadingService.show(false);
              this.toastr.error('Error: ' + this.errorMsg, undefined, {
                progressBar: true,
                timeOut: 5000,
              });
            }
          },
        });
      }
    }
  }
}
